
// import React from "react";
// import { Helmet } from "react-helmet";
// import "../css/home.css";

// function Header() {
//   return (
//     <>
//       <Helmet>
//         <meta charSet="utf-8" />
//         <title>Chalachitra Vaachana</title>

//           <link rel="preload" as="image" href="../images/assets/slider-02-ppYNYw1-.png" />
//           <link rel="preload" as="image" href="../images/assets/slider-03-ppYNYw1-.png" />
//         <link href="http://fonts.googleapis.com/css?family=Open+Sans:400,300,700" rel="stylesheet" />
//         <link href="/plugins/font-awesome.min.css" rel="stylesheet" />
//         <link href="/plugins/ionicons.min.css" rel="stylesheet" />
//         <link href="/plugins/jquery.fancybox.css" rel="stylesheet" />
//         <link href="/plugins/bootstrap/bootstrap.min.css" rel="stylesheet" />
//         <link href="/css/owl-carousel/owl.carousel.css" rel="stylesheet" />
//         <link href="/css/owl-carousel/owl.theme.css" rel="stylesheet" />
//         <link href="/css/template-style.css" rel="stylesheet" />
//         <link href="/plugins/slit-slider.css" rel="stylesheet" />
//         <link href="/plugins/animate.css" rel="stylesheet" />
//         <link href="/css/style.css" rel="stylesheet" />
//       </Helmet>
//       <a href="#main-content" className="sr-only sr-only-focusable">
//         Skip to main content
//       </a>
//             <header className="header header_style_01 fixed-menu fixed-top animated-header" 
//       id="navigation"  role="banner">
//         <div className="container-fluid">
//           <nav
//             className="navbar header-nav navbar-expand-lg"
//             role="navigation"
//             aria-label="Main navigation"
//           >
//             <div className="container-fluid top-head">

//               <div className="col-lg-8 col-md-6 col-sm-4">
//                 <div className="container">
//                   <button
//                     className="navbar-toggler text-body-inverted pull-left"
//                     type="button"
//                     data-bs-toggle="collapse"
//                     data-bs-target="#navbarSupportedContent"
//                     aria-controls="navbarSupportedContent"
//                     aria-expanded="false"
//                     aria-label="Toggle navigation menu"
//                   >
//                    <span className="navbar-toggler-icon text-body-inverted">

//                       <i aria-hidden="true"></i>
//                     </span>
//                   </button>


//                   <a className="navbar-brand" href="/" aria-label="Go to home page">
//                     <img
//                       src="/images/logos/logo-ccv.png"
//                       alt="Chalachitra Vaachana"
//                     />
//                   </a>                    
//                   <div className="collapse navbar-collapse justify-content-end pull-right nav-link-top" id="navbarSupportedContent">
                    
//                     <ul className="navbar-nav ml-auto text-center pull-right col-xs-12" 
//                     id="nav" role="menubar">
                     
//                       <li className="nav-item" id="home-header-navitem" role="none">
//                         <a className="nav-link" id="heade-navitem-a" href="#home-slider"
//                          role="menuitem" onClick={(e) => {
//                           e.preventDefault();
//                           const el = document.getElementById("home-slider");
//                           if (el) el.scrollIntoView({ behavior: "smooth" });
//                         }}>
//                           Home
//                         </a>
//                       </li>
//                       <li className="nav-item" id="home-header-navitem" role="none">
//                         <a className="nav-link" id="heade-navitem-a" role="menuitem" href="#about" onClick={(e) => {
//                           e.preventDefault();
//                           const el = document.getElementById("about");
//                           if (el) el.scrollIntoView({ behavior: "smooth" });
//                         }}>
//                           About
//                         </a> </li>
//                       <li className="nav-item" id="home-header-navitem" role="none">
//                         <a className="nav-link cursor-not-allowed text-gray-400" role="menuitem"
//                           aria-disabled="true" id="heade-navitem-a" href="#bestfeature" onClick={(e) => {
//                           e.preventDefault();
//                           const el = document.getElementById("help");
//                           if (el) el.scrollIntoView({ behavior: "smooth" });
//                         }}>
//                           Best Feature
//                         </a>

//                       </li>
//                       <li className="nav-item" id="home-header-navitem" role="none">
//                         <a className="nav-link cursor-not-allowed text-gray-400" role="menuitem"
//                           aria-disabled="true" id="heade-navitem-a" href="#howitworks" 
//                           onClick={(e) => {
//                           e.preventDefault();
//                           const el = document.getElementById("help");
//                           if (el) el.scrollIntoView({ behavior: "smooth" });
//                         }}>
//                           How It Works
//                         </a>

//                       </li>
//                       <li className="nav-item" id="home-header-navitem" role="none">
//                         <a className="nav-link" href="#contact" role="menuitem"
//                          id="heade-navitem-a" onClick={(e) => {
//                           e.preventDefault();
//                           const el = document.getElementById("contact");
//                           if (el) el.scrollIntoView({ behavior: "smooth" });
//                         }}>
//                           Contact
//                         </a>
//                       </li>
//                     </ul>
//                   </div>

//                 </div>
//               </div>
//               <div className="col-lg-4 col-md-6 col-sm-8 text-right header-logos"  role="group"
//   aria-label="Partner organizations">
//               <img src="/images/logos/meitylogo.png"
//               alt="Ministry of Electronics and Information Technology logo"  tabIndex="0"/>
//                 <img src="/images/logos/cdac.png" alt="Centre for Development of Advanced Computing logo"  tabIndex="0" />
//                 <img src="/images/logos/amritalogo.png" alt="Amrita Vishwa Vidyapeetham logo"  tabIndex="0" />
//               </div>

//             </div>
//           </nav>         
//         </div>
//       </header>
//     </>
//   );
// }

// export default Header;















//uderline active

// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet";

// function Header() {
//   const [activeTab, setActiveTab] = useState("home");
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

//   // Handle scroll effect for professional shadow
//   useEffect(() => {
//     const handleScroll = () => setIsScrolled(window.scrollY > 20);
//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   const handleNavClick = (e, sectionId) => {
//     e.preventDefault();
//     setActiveTab(sectionId);
//     setIsMobileMenuOpen(false);
//     const targetId = sectionId === "home" ? "home-slider" : sectionId;
//     const el = document.getElementById(targetId);
//     if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Chalachitra Vaachana</title>
//         <style>{`
//           /* 1. MAIN HEADER CONTAINER */
//           .main-header {
//             background: #ffffff !important;
//             height: 90px;
//             display: flex;
//             align-items: center;
//             position: fixed;
//             top: 0;
//             width: 100%;
//             z-index: 1000;
//             transition: all 0.3s ease;
//             box-shadow: ${isScrolled ? "0 4px 20px rgba(0,0,0,0.06)" : "none"};
//           }

//           .header-container {
//             width: 100%;
//             max-width: 1440px;
//             margin: 0 auto;
//             padding: 0 40px;
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//           }

//           /* 2. LOGO SECTION */
//           .logo-brand img {
//             height: 60px;
//             width: auto;
//             display: block;
//           }

//           /* 3. NAVIGATION LINKS (IMAGE 1 STYLE) */
//           .nav-wrapper {
//             display: flex;
//             gap: 35px;
//             align-items: center;
//           }

//           .nav-item-link {
//             color: #5C64A6 !important;
//             font-size: 15px;
//             font-weight: 700;
//             text-decoration: none !important;
//             text-transform: uppercase;
//             padding: 10px 0;
//             position: relative;
//             transition: color 0.3s ease;
//           }

//           /* THE UNDERLINE INDICATOR FROM IMAGE 1 */
//           .nav-item-link::after {
//             content: "";
//             position: absolute;
//             bottom: -5px;
//             left: 0;
//             width: 0;
//             height: 5px; /* Thick underline */
//             background-color: #5C64A6;
//             border-radius: 10px; /* Rounded corners for the line */
//             transition: width 0.3s ease;
//           }

//           /* ✅ ACTIVE TAB STYLE */
//           .nav-item-link.active::after {
//             width: 100%;
//           }

//           .nav-item-link:hover {
//             color: #4a518a !important;
//           }

//           /* 4. PARTNER LOGOS */
//           .partner-logos {
//             display: flex;
//             align-items: center;
//             gap: 20px;
//           }

//           .partner-logos img {
//             height: 45px;
//             width: auto;
//             object-fit: contain;
//           }

//           /* 5. MOBILE RESPONSIVENESS */
//           .mobile-btn {
//             display: none;
//             background: none;
//             border: none;
//             color: #5C64A6;
//             font-size: 28px;
//             cursor: pointer;
//           }

//           @media (max-width: 1200px) {
//             .header-container { padding: 0 20px; }
//             .nav-wrapper { gap: 20px; }
//           }

//           @media (max-width: 991px) {
//             .partner-logos { display: none; }
//             .mobile-btn { display: block; }
            
//             .nav-wrapper {
//               position: absolute;
//               top: 90px;
//               left: 0;
//               width: 100%;
//               background: white;
//               flex-direction: column;
//               padding: 30px;
//               gap: 20px;
//               box-shadow: 0 10px 20px rgba(0,0,0,0.1);
//               transform: translateY(${isMobileMenuOpen ? "0" : "-150%"});
//               opacity: ${isMobileMenuOpen ? "1" : "0"};
//               transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//               pointer-events: ${isMobileMenuOpen ? "all" : "none"};
//             }

//             .nav-item-link { width: 100%; text-align: center; }
//             .nav-item-link::after { left: 25%; width: 0; }
//             .nav-item-link.active::after { width: 50%; }
//           }

//           @media (max-width: 480px) {
//             .main-header { height: 75px; }
//             .logo-brand img { height: 45px; }
//           }
//         `}</style>
//       </Helmet>

//       <header className="main-header" role="banner">
//         <div className="header-container">
          
//           <div className="logo-brand">
//             <a href="/" onClick={(e) => handleNavClick(e, "home")}>
//               <img src="/images/logos/logo-ccv.png" alt="Chalachitra Vaachana" />
//             </a>
//           </div>

//           <nav className="nav-wrapper">
//             {[
//               { id: "home", label: "Home" },
//               { id: "about", label: "About" },
//               { id: "bestfeature", label: "Best Feature" },
//               { id: "howitworks", label: "How It Works" },
//               { id: "contact", label: "Contact" }
//             ].map((item) => (
//               <a
//                 key={item.id}
//                 href={`#${item.id}`}
//                 className={`nav-item-link ${activeTab === item.id ? "active" : ""}`}
//                 onClick={(e) => handleNavClick(e, item.id)}
//               >
//                 {item.label}
//               </a>
//             ))}
//           </nav>

//           <div className="partner-logos">
//             <img src="/images/logos/meitylogo.png" alt="MeitY" />
//             <img src="/images/logos/cdac.png" alt="C-DAC" />
//             <img src="/images/logos/amritalogo.png" alt="Amrita" />
//           </div>

//           <button className="mobile-btn" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
//             {isMobileMenuOpen ? "✕" : "☰"}
//           </button>

//         </div>
//       </header>

//       {/* Spacer so content starts below the fixed header */}
//       <div style={{ height: "90px" }}></div>
//     </>
//   );
// }

// export default Header;


//background blue
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Navbar, Nav, Container } from "react-bootstrap";
import { List } from "react-bootstrap-icons"; // Ensure you have bootstrap-icons installed
import "../css/home.css";

function Header() {
  const [activeSection, setActiveSection] = useState("home");
  const [expanded, setExpanded] = useState(false);

  const handleNavClick = (sectionId) => {
    setActiveSection(sectionId);
    setExpanded(false); // Close mobile menu on click
    const el = document.getElementById(sectionId === "home" ? "home-slider" : sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Chalachitra Vaachana</title>


          <link rel="preload" as="image" href="../images/assets/slider-02-ppYNYw1-.png" />
           <link rel="preload" as="image" href="../images/assets/slider-03-ppYNYw1-.png" />
         <link href="http://fonts.googleapis.com/css?family=Open+Sans:400,300,700" rel="stylesheet" />
         <link href="/plugins/font-awesome.min.css" rel="stylesheet" />
         <link href="/plugins/ionicons.min.css" rel="stylesheet" />
         <link href="/plugins/jquery.fancybox.css" rel="stylesheet" />
         <link href="/plugins/bootstrap/bootstrap.min.css" rel="stylesheet" />
         <link href="/css/owl-carousel/owl.carousel.css" rel="stylesheet" />
         <link href="/css/owl-carousel/owl.theme.css" rel="stylesheet" />
         <link href="/css/template-style.css" rel="stylesheet" />
         <link href="/plugins/slit-slider.css" rel="stylesheet" />
         <link href="/plugins/animate.css" rel="stylesheet" />
         <link href="/css/style.css" rel="stylesheet" />

        <style>{`
          /* 1. Navbar Base - Modern Purple */
          .header_style_01 {
            background: #fff !important;
            padding: 10px 0;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            transition: all 0.3s ease;
          }

          /* 2. Professional Pill Logic */
          // .nav-link-custom {
          //   color: #b0004e !important;
          //   font-weight: 600;
          //   padding: 10px 24px !important;
          //   border-radius: 50px;
          //   transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          //   margin: 0 4px;
          //   text-align: center;
          //   cursor: pointer;
          //   text-decoration: none !important;
          //   display: inline-block;
          // }
.nav-link-custom {
  color: #b0004e !important;
  font-weight: 700;           /* Bolder text */
  font-size: 18px;            /* Increased from default (~16px) to 18px */
  padding: 12px 28px !important; /* Larger pill for better click area */
  border-radius: 50px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 6px;
  text-align: center;
  cursor: pointer;
  text-decoration: none !important;
  display: inline-block;
}
          .nav-link-custom:hover {
            color: #ffffff !important;
            background: #b0004e;
          }

          /* 3. ACTIVE TAB - White Pill with Brand Text */
          .nav-link-custom.active {
            color: #fff !important;/* Purple text on white */
            background-color: #b0004e !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            transform: translateY(-1px);
          }

          /* 4. Logo Sizing */
          .navbar-brand img {
            max-height: 55px;
            width: auto;
          }

          /* 5. Partner Logos (Right Side) */
          .header-logos img {
            height: 50px;
            margin-left: 8px;
          }

          /* 6. RESPONSIVE QUERIES (Small Devices) */
          @media (max-width: 991px) {
            .nav-link-custom {
              margin: 8px 0;
              width: 100%; /* Full width pills on mobile */
              padding: 12px !important;
            }
            
            .navbar-collapse {
              background: #fff !important;
              padding: 20px;
              border-radius: 15px;
              margin-top: 10px;
            }

            .header-logos {
              display: flex;
              justify-content: center;
              margin-top: 15px;
              border-top: 1px solid rgba(255,255,255,0.1);
              padding-top: 15px;
            }
          }

          /* 7. Extra Large Screen Fit */
          @media (min-width: 1400px) {
            .container-fluid {
              padding-left: 8%;
              padding-right: 8%;
            }
          }
        `}</style>
      </Helmet>

      <header className="header header_style_01 fixed-top" role="banner">
        <Container fluid>
          <Navbar expand="lg" expanded={expanded} variant="dark" className="p-0">
            {/* Logo Left */}
            <Navbar.Brand href="/" onClick={() => handleNavClick("home")}>
              <img src="/images/logos/logo-ccv.png" alt="Chalachitra Vaachana" />
            </Navbar.Brand>

            {/* Hamburger for Mobile */}
            <Navbar.Toggle 
              aria-controls="basic-navbar-nav" 
              className="border-0" 
              onClick={() => setExpanded(!expanded)}
            >
              <List size={30} color="white" />
            </Navbar.Toggle>

            <Navbar.Collapse id="basic-navbar-nav">
              {/* Central Links - Responsive Pills */}
              <Nav className="mx-auto">
                <a 
                  className={`nav-link-custom ${activeSection === "home" ? "active" : ""}`} 
                  onClick={() => handleNavClick("home")}
                >
                  Home
                </a>
                <a 
                  className={`nav-link-custom ${activeSection === "about" ? "active" : ""}`} 
                  onClick={() => handleNavClick("about")}
                >
                  About
                </a>
                <a 
                  className={`nav-link-custom ${activeSection === "bestfeature" ? "active" : ""}`} 
                  onClick={() => handleNavClick("bestfeature")}
                >
                  Features
                </a>
                <a 
                  className={`nav-link-custom ${activeSection === "howitworks" ? "active" : ""}`} 
                  onClick={() => handleNavClick("howitworks")}
                >
                  Workflow
                </a>
                <a 
                  className={`nav-link-custom ${activeSection === "contact" ? "active" : ""}`} 
                  onClick={() => handleNavClick("contact")}
                >
                  Contact
                </a>
              </Nav>

              {/* Partner Logos Right */}
              <div className="header-logos d-none d-md-flex align-items-center">
                <img src="/images/logos/meitylogo.png" alt="MeitY" />
                <img src="/images/logos/cdac.png" alt="C-DAC" />
                <img src="/images/logos/amritalogo.png" alt="Amrita" />
              </div>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </header>
    </>
  );
}

export default Header;